import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('filter', true, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    fill: props.colors[1],
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    points: "6 9 20.4 25.8177778 20.4 38.4444444 27.6 42 27.6 25.8177778 42 9"
  }))));
});